export default {
  title: 'HiTeach課堂小桌遊',
  pvpGame: '摘星星',
  moleGame: '打地鼠',
  tfGame: '火箭升空',
  pickGame: '挑人轉盤',
  punchBoardGame: '戳戳樂',
  moreManagement: '更多遊戲管理',
  snakeGame: '詞彙貪食蛇',
  mazeGame: '迷宮',

  // 遊戲說明標題
  gameInfoTitle: '遊戲說明',
  close: '關閉',
  
  // 詞彙掉落說明
  pvpGameTitle: '摘星星',
  pvpGameDesc: '在熱帶小島上，詞語像流星雨般從天而降！\n兩位玩家要在限定時間內，抓住正確詞語、閃避錯誤選項，誰能快速又精準地成為詞彙獵人王？',
  
  // 打地鼠說明
  moleGameTitle: '打地鼠',
  moleGameDesc: '一人對戰！知識版的打地鼠登場～\n地鼠們冒出頭帶來真假資訊，你能在最短時間內準確「敲」出正確答案，擊退那些來搞亂的錯誤嗎？',
  
  // 火箭升空說明
  tfGameTitle: '火箭升空',
  tfGameDesc: '準備升空，智慧對決啟動！\n兩位太空人面對是非題的挑戰，答對才能讓火箭直衝星際，答錯就原地打轉～誰能最先飛出大氣層成為知識宇航員？',
  
  // 挑人轉盤說明
  pickGameTitle: '挑人轉盤',
  pickGameDesc: '牽動命運的轉盤！\n讓選擇變得更有趣更公平。轉盤旋轉，答案揭曉！',
  
  // 戳戳樂說明
  punchBoardGameTitle: '戳戳樂',
  punchBoardGameDesc: '戳破驚喜的時刻！\n每個洞都藏著不同的驚喜，戳破表面探索內容。支援多種版面大小和動畫效果，讓選擇充滿期待！',

  // 更多遊戲管理說明
  moreManagementTitle: '更多遊戲管理',
  moreManagementDesc: '管理你的遊戲設定與內容！\n在這裡可以查看所有遊戲的詳細設定、管理遊戲題目、調整遊戲參數，讓你的課堂遊戲更加個性化和豐富！',

  // 貪食蛇說明
  snakeGameTitle: '詞彙貪食蛇',
  snakeGameDesc: '經典重現！知識版貪食蛇來襲～\n控制貪食蛇在迷宮中穿梭，吃到正確答案的食物讓蛇身變長，小心不要撞到自己或牆壁！考驗你的反應力與知識力！',

  // 迷宮說明
  mazeGameTitle: '迷宮',
  mazeGameDesc: '闖關冒險！智慧迷宮等你挑戰～\n在迷宮中尋找正確的路徑，最快找到出口的就是迷宮大師！',

  // 按鈕文字
  play: '開始遊戲',
  enterManagement: '進入管理',

  // 校園版授權警告
  schoolVersionWarning: '目前學校未取得校園版授權！',

  // 通用遊戲設定（用於多個遊戲）
  useHiTeachRoster: '使用 HiTeach 目前上課名單',
  rosterEmptyWarning: '目前名單為空，將使用預設匿名模式',

  // 推送相關
  pushSuccess: '推送成功',
  pushFailed: '推送失敗：{message}',
  tokenRefreshing: '正在更新驗證資訊...',

  // 查看成績相關
  viewScores: '查看成績',
  noActivityPushed: '尚未推送活動，無法查看成績',
  canViewScores: '推送成功！您可以點擊查看成績按鈕查看學生提交的成績',

  // 活動數量限制
  activityLimitExceeded: '已達活動數量上限（{maxLimit} 個），請至遊戲管理刪除部分活動後再試！'
}